<script setup lang="ts">
// import VConsole from 'vconsole'

onMounted(() => {
  const url_params: any = useUrlSearchParams('history')
  const params = useUrlSearchParams('hash')
  localStorage.setItem('hash', window.location.hash)
  if (params.c || url_params.c)
    sessionStorage.setItem('canal', 'ALF')
  // 是否校验身份证必填
  if (params.check || url_params.check)
    sessionStorage.setItem('check', '1')
  // console.error('--canal-->', sessionStorage.getItem('canal'))
  // if (import.meta.env.VITE_BASE_FLAG === 'dev')
  // sessionStorage.setItem('openid', 'o2KRx6U1YwUDp0ctC55dCIh8QYLI')
  // new VConsole()
})
</script>

<template>
  <!-- 开启顶部安全区适配 -->
  <van-nav-bar safe-area-inset-top />
  <!-- 开启底部安全区适配 -->
  <van-number-keyboard safe-area-inset-bottom />
  <router-view />
</template>
